import KidsMode from 'commons/KidsMode/KidsMode';

export default class TransparentHeaderAtTop {
  constructor({ element: $element }){
    this.element = $element;
  }

  init() {
    if (KidsMode.isActive()) {
      return;
    }

    if (this.hasPremiumHeadline()) {
      this.bindScroll();
      this.addTransparentHeader();
      this.addClassToArticleContainer('has-premium-headline');
    }

    if (this.hasTagHeader()) {
      this.addClassToArticleContainer('has-tag-header');
    }

    this.bindClickButton();
  }

  bindScroll() {
    document.addEventListener('scroll', this.addTransparentHeader.bind(this));
  }

  bindClickButton() {
    const kidsActivateButton = this.element.querySelector('.kids-menu__button');
    if(kidsActivateButton) {
      kidsActivateButton.addEventListener('click', () => KidsMode.activate());
    }
  }

  addTransparentHeader() {
    if (this.getScrollTop() > 0) {
      this.element.classList.remove('transparent-header');
    } else {
      this.element.classList.add('transparent-header');
    }
  }

  getScrollTop() {
    return window.pageYOffset || document.documentElement.scrollTop;
  }

  hasPremiumHeadline() {
    let premiumHeadlineSections = document.querySelectorAll('section[data-component="PremiumHeadline"]');
    return premiumHeadlineSections.length > 0;
  }

  hasTagHeader() {
    let tagHeader = document.querySelector('.tag-header');
    return tagHeader !== null;
  }

  addClassToArticleContainer(classname) {
    let article = document.querySelector('#article-container');
    article !== null && article.classList.add(classname); // jshint ignore:line
  }
}
